/**
 * Typography — font family mappings for DUEL.
 *
 * Headers use Oswald (condensed, industrial).
 * Body uses Inter (clean, readable).
 *
 * Usage:
 *   import { TYPO } from '@/constants/typography';
 *   { fontFamily: TYPO.heading.bold, fontSize: FONT['2xl'] }
 */

/** Oswald heading families keyed by weight */
export const HEADING_FAMILY = {
  regular: 'Oswald_400Regular',
  medium: 'Oswald_500Medium',
  semibold: 'Oswald_600SemiBold',
  bold: 'Oswald_700Bold',
} as const;

/** Inter body families keyed by weight */
export const BODY_FAMILY = {
  regular: 'Inter_400Regular',
  medium: 'Inter_500Medium',
  semibold: 'Inter_600SemiBold',
  bold: 'Inter_700Bold',
} as const;

/** Barlow Condensed subheading families keyed by weight */
export const SUBHEADING_FAMILY = {
  regular: 'BarlowCondensed_400Regular',
  semibold: 'BarlowCondensed_600SemiBold',
  bold: 'BarlowCondensed_700Bold',
  extrabold: 'BarlowCondensed_800ExtraBold',
} as const;

/** Shorthand for common usage */
export const TYPO = {
  heading: HEADING_FAMILY,
  body: BODY_FAMILY,
  subheading: SUBHEADING_FAMILY,
} as const;
